export const LANGUAGE_CODE = 'ja-JP';
export const MARKET_CODE = 'JPN';
export const CURRENCY_CODE = 'JPY';
export const YAKKAN_URL = 'https://travel.rakuten.co.jp/info/yakkan/tehai.html';
export const SITE_IMAGE_URL =
  'https://img.travel.rakuten.co.jp/share/common/images/bnr_ogp_logo.gif';
export const FAVORITE_LINK_MAIN = 'favoritelist.travel.rakuten.co.jp/hotel/';
export const FAVORITE_DOMESTIC_LINK = 'favoritelist.travel.rakuten.co.jp/hotel/domestic';
export const FAVORITE_OVERSEAS_LINK = 'favoritelist.travel.rakuten.co.jp/hotel/overseas';
export const BREADCRUMB_TOP_PAGE_LINK_TEXT = '楽天トラベルトップ';
export const BREADCRUMB_FAVORITE_LIST_LINK_TEXT = 'お気に入りページ';
export const FAVORITE_PAGE_TITLE_DOMESTIC = 'お気に入りリスト（国内ホテル）';
export const FAVORITE_PAGE_TITLE_OVERSEAS = 'お気に入りリスト（海外ホテル）';
export const FAVORITE_DOMESTIC_LINK_TEXT = '国内のお気に入りへ';
export const FAVORITE_OVERSEAS_LINK_TEXT = '海外のお気に入りへ';
export const FAVORITE_TAB_TITLE_DOMESTIC = '楽天トラベル：お気に入りリスト（国内ホテル）';
export const FAVORITE_TAB_TITLE_OVERSEAS = '楽天トラベル：お気に入りリスト（海外ホテル）';
